// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PersonalApiKey,
  PersonalApiKeyFromJSON,
  PersonalApiKeyToJSON,
} from "../models/PersonalApiKey";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface CreatePersonalApiKeyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  id: string;
}

export interface DeletePersonalApiKeyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  id: string;
  /**
   *
   */
  prefix: string;
}

export interface JobCreatePersonalApiKeyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  xJobSecret: string;
}

export interface JobDeletePersonalApiKeyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  prefix: string;
  /**
   *
   */
  xJobSecret: string;
}

export interface RevokePersonalApiKeyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  id: string;
  /**
   *
   */
  prefix: string;
}

export interface SyncHccUsersRequest {
  /**
   *
   */
  tenantId: string;
}

/**
 *
 */
export class ThreediUserApi extends runtime.BaseAPI {
  /**
   * Creates request options for createPersonalApiKey without sending the request
   */
  async createPersonalApiKeyRequestOpts(
    requestParameters: CreatePersonalApiKeyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling createPersonalApiKey().'
      );
    }

    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling createPersonalApiKey().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users/{id}/3di-personal-api-keys`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * create a 3Di personal api key
   * Create a 3Di personal api key
   */
  async createPersonalApiKeyRaw(
    requestParameters: CreatePersonalApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PersonalApiKey>> {
    const requestOptions = await this.createPersonalApiKeyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PersonalApiKeyFromJSON(jsonValue));
  }

  /**
   * create a 3Di personal api key
   * Create a 3Di personal api key
   */
  async createPersonalApiKey(
    requestParameters: CreatePersonalApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PersonalApiKey> {
    const response = await this.createPersonalApiKeyRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for deletePersonalApiKey without sending the request
   */
  async deletePersonalApiKeyRequestOpts(
    requestParameters: DeletePersonalApiKeyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling deletePersonalApiKey().'
      );
    }

    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling deletePersonalApiKey().'
      );
    }

    if (requestParameters["prefix"] == null) {
      throw new runtime.RequiredError(
        "prefix",
        'Required parameter "prefix" was null or undefined when calling deletePersonalApiKey().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users/{id}/3di-personal-api-keys/{prefix}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace("{prefix}", encodeURIComponent(String(requestParameters["prefix"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete a 3Di personal api key
   * Delete 3Di personal api key
   */
  async deletePersonalApiKeyRaw(
    requestParameters: DeletePersonalApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.deletePersonalApiKeyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a 3Di personal api key
   * Delete 3Di personal api key
   */
  async deletePersonalApiKey(
    requestParameters: DeletePersonalApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.deletePersonalApiKeyRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for jobCreatePersonalApiKey without sending the request
   */
  async jobCreatePersonalApiKeyRequestOpts(
    requestParameters: JobCreatePersonalApiKeyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobCreatePersonalApiKey().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobCreatePersonalApiKey().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobCreatePersonalApiKey().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/3di-personal-api-keys`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * create a 3Di personal api key from a job
   * Create a 3Di personal api key from job
   */
  async jobCreatePersonalApiKeyRaw(
    requestParameters: JobCreatePersonalApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PersonalApiKey>> {
    const requestOptions = await this.jobCreatePersonalApiKeyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PersonalApiKeyFromJSON(jsonValue));
  }

  /**
   * create a 3Di personal api key from a job
   * Create a 3Di personal api key from job
   */
  async jobCreatePersonalApiKey(
    requestParameters: JobCreatePersonalApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PersonalApiKey> {
    const response = await this.jobCreatePersonalApiKeyRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobDeletePersonalApiKey without sending the request
   */
  async jobDeletePersonalApiKeyRequestOpts(
    requestParameters: JobDeletePersonalApiKeyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobDeletePersonalApiKey().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobDeletePersonalApiKey().'
      );
    }

    if (requestParameters["prefix"] == null) {
      throw new runtime.RequiredError(
        "prefix",
        'Required parameter "prefix" was null or undefined when calling jobDeletePersonalApiKey().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobDeletePersonalApiKey().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/3di-personal-api-keys/{prefix}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));
    urlPath = urlPath.replace("{prefix}", encodeURIComponent(String(requestParameters["prefix"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete a 3Di personal api key from a job
   * Delete 3Di personal api key from job
   */
  async jobDeletePersonalApiKeyRaw(
    requestParameters: JobDeletePersonalApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.jobDeletePersonalApiKeyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a 3Di personal api key from a job
   * Delete 3Di personal api key from job
   */
  async jobDeletePersonalApiKey(
    requestParameters: JobDeletePersonalApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.jobDeletePersonalApiKeyRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for revokePersonalApiKey without sending the request
   */
  async revokePersonalApiKeyRequestOpts(
    requestParameters: RevokePersonalApiKeyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling revokePersonalApiKey().'
      );
    }

    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling revokePersonalApiKey().'
      );
    }

    if (requestParameters["prefix"] == null) {
      throw new runtime.RequiredError(
        "prefix",
        'Required parameter "prefix" was null or undefined when calling revokePersonalApiKey().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users/{id}/3di-personal-api-keys/{prefix}/revoke`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace("{prefix}", encodeURIComponent(String(requestParameters["prefix"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Revoke a 3Di personal api key
   * Revoke 3Di personal api key
   */
  async revokePersonalApiKeyRaw(
    requestParameters: RevokePersonalApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.revokePersonalApiKeyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Revoke a 3Di personal api key
   * Revoke 3Di personal api key
   */
  async revokePersonalApiKey(
    requestParameters: RevokePersonalApiKeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.revokePersonalApiKeyRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for syncHccUsers without sending the request
   */
  async syncHccUsersRequestOpts(
    requestParameters: SyncHccUsersRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling syncHccUsers().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/sync-all-hcc-users`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Sync all HCC roles
   * Sync all HCC roles for all users in this tenant
   */
  async syncHccUsersRaw(
    requestParameters: SyncHccUsersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.syncHccUsersRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Sync all HCC roles
   * Sync all HCC roles for all users in this tenant
   */
  async syncHccUsers(
    requestParameters: SyncHccUsersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.syncHccUsersRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
